import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../api/api';
import { TosContent } from './TosContent';
import '../styles/Login.css';

export const AcceptTos = () => {
    const [accepted, setAccepted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const { userProfile } = useAuth();

    // Navigate away once Firestore onSnapshot delivers the tos_accepted_at update
    useEffect(() => {
        if (userProfile?.tos_accepted_at) {
            navigate('/');
        }
    }, [userProfile?.tos_accepted_at, navigate]);

    const handleAccept = async (e) => {
        e.preventDefault();
        if (!accepted) return;

        setLoading(true);
        setError('');
        try {
            await api.post('/user/accept-tos');
            // Firestore onSnapshot will update userProfile.tos_accepted_at,
            // triggering the useEffect above to navigate.
        } catch (err) {
            setError('Failed to record acceptance. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container tos-container">
            <h2>Terms of Service</h2>
            <div className="tos-content">
                <TosContent />
            </div>

            <form onSubmit={handleAccept}>
                {error && <div className="error">{error}</div>}
                <div className="tos-checkbox">
                    <label>
                        <input
                            type="checkbox"
                            checked={accepted}
                            onChange={(e) => setAccepted(e.target.checked)}
                        />
                        {' '}I agree to the Terms of Service and{' '}
                        <a href="/privacy" target="_blank" rel="noopener noreferrer" className="auth-tos-link">
                            Privacy Policy
                        </a>
                    </label>
                </div>
                <button type="submit" disabled={!accepted || loading}>
                    {loading ? 'Accepting...' : 'Accept & Continue'}
                </button>
            </form>
        </div>
    );
};
